import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { eSize } from '../k-cards.component';
import { ICompanyItemCardData } from './k-company-item-card.interface';
import { companyItemImgPath, eCompanyItems } from 'app/services/companyItems/company-items.interface';
import { currencyImgPath, eCurrencies } from '../../info-icon/info-icon.interface';
import { eContracts } from 'app/services/contract/contract.config';
import { formatNum } from 'app/common/utils/number.util';

@Component({
  selector: 'k-company-item-card',
  templateUrl: './k-company-item-card.component.html',
  styleUrls: ['./k-company-item-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KCompanyItemCardComponent implements OnChanges {

  @Input() isResponsive: boolean = true;
  @Input() size: eSize = eSize.sm;
  @Output() onCardClick: EventEmitter<ICompanyItemCardData> = new EventEmitter<ICompanyItemCardData>();
  @Input() count: number = 0;
  @Input() data: ICompanyItemCardData = {
    id: eCompanyItems.LOOTBOX_BASIC,
    isNFTBound: false,
    title: 'LOOTBOX BASIC',
    shortDescription: 'Two Lines description about the product and some short informations',
    pic: companyItemImgPath()[eCompanyItems.LOOTBOX_BASIC],
    contract: eContracts.Lootbox,
    idOnchain: '0x4c4f4f54424f585f424153494300000000000000000000000000000000000000',
    candyPrice: "1.27",
    dollarPrice: 19,
    prices: [
      {
        price: '628k',
        currency: {
          name: "Kryptomon",
          symbol: eCurrencies.KMON,
          address: "0xa67375293613b4E081855E605504ba54be6Af139"
        }
      }
    ]
  };
  kmonAmount: string
  kmonCurrencyIcon: string = currencyImgPath()[eCurrencies.KMON];
  handledCurrencies: string[] = [];

  constructor() {
    for (let curr in eCurrencies) {
      this.handledCurrencies.push(curr);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data && !this.data.pic) this.data.pic = companyItemImgPath()[this.data.id]
    if (this.data?.prices) this.kmonAmount = formatNum(parseFloat(this.data.prices.filter(p => p.currency.symbol == 'KMON')[0].price));
  }

  click() {
    this.onCardClick.emit(this.data);
  }
}
